import React from 'react';

const ModuleIcon = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M27.625 16.8949C27.625 16.7371 27.5263 16.5962 27.378 16.5424L22 14.5867V8.32331H21.9855C22.0399 8.13464 21.938 7.93622 21.753 7.8705L16.128 5.82534C16.0454 5.79487 15.9546 5.79487 15.872 5.82534L10.247 7.8705C10.127 7.91461 10.0377 8.01665 10.0098 8.14144H10V14.5867L4.62203 16.5424C4.50203 16.5865 4.41269 16.6885 4.38484 16.8133H4.375V23.4611H4.38437C4.34308 23.645 4.44484 23.8309 4.62203 23.8952L10.247 25.9403C10.3296 25.971 10.4204 25.971 10.503 25.9403L16 23.9416L21.497 25.9403C21.5796 25.971 21.6704 25.971 21.753 25.9403L27.378 23.8952C27.4919 23.8538 27.5787 23.7598 27.6109 23.643H27.625V16.9952C27.625 16.9952 27.6247 16.9288 27.625 16.8949ZM10 25.0525L5.125 23.2802V17.4302L10 19.203V25.0525ZM10.375 18.5411L5.84734 16.8949L10.3455 15.2589L14.8736 16.9057L10.375 18.5411ZM15.625 23.2802L10.75 25.0525V19.203L15.625 17.4302V23.2802ZM15.625 16.3596L10.75 14.5867V8.75831L15.625 10.5311V16.3596ZM11.4723 8.223L16 6.57675L20.5277 8.223L16 9.86925L11.4723 8.223ZM21.25 8.75831V14.5867L16.375 16.3596V10.5311L21.25 8.75831ZM21.25 25.0525L16.375 23.2802V17.4302L21.25 19.203V25.0525ZM21.625 18.5411L17.1264 16.9057L21.6545 15.2589L26.1527 16.8949L21.625 18.5411ZM26.875 23.2802L22 25.0525V19.203L26.875 17.4302V23.2802Z'
        fill='#3F4756'
        stroke='#3F4756'
        strokeWidth='0.2'
      />
    </svg>
  );
};

export default ModuleIcon;
